import React, { useContext, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import './Orders.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { DataContext } from '../../context/DataContext';
import { orderFormatDate } from '../../utils/CommonFunctions';
import { orderStatus } from '../../utils/Constant';
import { orderCancelRequest } from '../../utils/cakeryAPI';

const theme = createTheme({
  typography: {
    fontFamily: 'Poppins, sans-serif',
  },
  palette: {
    price: {
      main: '#FF1E54',
    },
  },
});

const MyOrders = () => {
  const { myOrdersList, setMyOrdersList, GetMyOrders, setIsPreloaderShow } =
    useContext(DataContext);

  useEffect(() => {
    const fetchOrders = async () => {
      await GetMyOrders();
    };
    setMyOrdersList(null);
    fetchOrders();
  }, []);

  const handleOrderCancelRequest = async (orderID) => {
    try {
      setIsPreloaderShow(true);
      let requestData = {
        cake_order_id: orderID,
        delivery_status: 7,
      };
      const orderCancelRequestResponse = await orderCancelRequest(requestData);
      await GetMyOrders();
    } catch (error) {
      console.error(error);
    } finally {
      setIsPreloaderShow(false);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Typography variant="h6" className="cart-order-title">
        Orders
      </Typography>
      <div>
        {myOrdersList?.length > 0 ? (
          myOrdersList.map((order) =>
            order.cart_items.map((item, itemIndex) => (
              <Box className="cart-order" key={`${order.id}-${itemIndex}`}>
                <Box display="flex" alignItems="center" className="order-item">
                  <img
                    src={item?.cake_price?.cake?.images_list?.[0]?.url}
                    className="order-cake-image"
                    alt={item?.cake_price?.cake?.name || 'Cake Image'}
                  />
                  <Box>
                    <Typography variant="h6" className="cake-name">
                      {item?.cake_price?.cake?.name}
                    </Typography>
                    <Typography variant="body2" className="cake-price">
                      <span className="rs-font">₹</span>
                      {item?.price}/{item?.cake_price?.kg?.kg} Kg * {item?.qty}{' '}
                      Qty
                    </Typography>
                    <Typography variant="body2" className="cake-event-date">
                      Greeting: {item?.greeting_text}
                    </Typography>
                    <Typography variant="body2" className="cake-event-date">
                    Occasion Date: {item?.occasion?.date ? orderFormatDate(item.occasion.date) : ''}                    </Typography>
                  </Box>
                </Box>
                <Box display="flex" flexDirection="column" alignItems="flex-end">
                  <Typography variant="body1" className="order-status">
                    {orderStatus[order?.delivery_status]}
                  </Typography>
                  {[1, 2, 3].includes(order?.delivery_status) && (
                    <Button
                      variant="outlined"
                      className="order-button order-cancel"
                      onClick={() => handleOrderCancelRequest(order?.id)}
                    >
                      Cancel Order
                    </Button>
                  )}
                  {[5].includes(order?.delivery_status) && (
                    <Button
                      variant="contained"
                      className="order-button order-rate-review"
                    >
                      <FontAwesomeIcon icon={faStar} /> Rate & Review
                    </Button>
                  )}
                </Box>
              </Box>
            ))
          )
        ) : (
          <Box
            className="cart-order order-no-items"
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="100px"
          >
            <Typography className="rs-font">No orders</Typography>
          </Box>
        )}
        {/* {myOrdersList?.length > 0 ? (
    myOrdersList.map((order, index) => (
      <Box className="cart-order" key={index}>
        {order.cart_items.map((item, itemIndex) => (
          <Box key={itemIndex} display="flex" alignItems="center" className="order-item">
            <img
              src={item?.cake_price?.cake?.images_list?.[0]?.url}
              className="order-cake-image"
              alt={item?.cake_price?.cake?.name || "Cake Image"}
            />
            <Box>
              <Typography variant="h6" className="cake-name">
                {item?.cake_price?.cake?.name}
              </Typography>
              <Typography variant="body2" className="cake-price">
                <span className="rs-font">₹</span>{item?.price}/{item?.cake_price?.kg?.kg}{" Kg"} * {item?.qty} Qty
              </Typography>
              <Typography variant="body2" className="cake-event-date">
                Greeting: {item?.greeting_text}
              </Typography>
              <Typography variant="body2" className="cake-event-date">
                Occasion Date: {orderFormatDate(item?.occasion?.date)}
              </Typography>
            </Box>
          </Box>
        ))}
        <Box display="flex" flexDirection="column" alignItems="flex-end">
          <Typography variant="body1" className="order-status">
            {orderStatus[order?.delivery_status]}
          </Typography>
          {[1, 2, 3].includes(order?.delivery_status) && (
            <Button
              variant="outlined"
              className="order-button order-cancel"
              onClick={() => handleOrderCancelRequest(order?.id)}
            >
              Cancel Order
            </Button>
          )}
          {[5].includes(order?.delivery_status) && (
            <Button
              variant="contained"
              className="order-button order-rate-review"
            >
              <FontAwesomeIcon icon={faStar} /> Rate & Review
            </Button>
          )}
        </Box>
      </Box>
    ))
  ) : (
    <Box
      className="cart-order order-no-items"
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100px"
    >
      <Typography className="rs-font">No orders</Typography>
    </Box>
  )} */}
      </div>
    </ThemeProvider>
  );
};

export default MyOrders;
